export default __webpack_public_path__ + "static/media/biofit-builder-series-UU.392798ae.png";